import React from 'react';
import { useSelector } from 'react-redux';
import { getTransactionHistory } from '../../../ducks/selectors';
import {
  TransactionHistoryCardWrapper,
  CardTitle,
  TransactionHistoryLink,
  NoTransactionsText,
} from './TransactionHistoryCard.styles';
import TransactionHistoryItems from '../../future-packages/transaction-history-items/TransactionHistoryItems';
import { TRANSACTION_HISTORY_CARD_ROW_LENGTH } from '../../../constants';
import { useDualEventTracking } from '../../../utils/useDualEventTracking';

const TransactionHistoryCard = ({ vehicleId }: any) => {
  const { trackEvent } = useDualEventTracking();
  const handleLinkClick = () => {
    trackEvent('v2_loan_details_view_all_transactions_button_tap');
  };

  const fullTransactionHistoryList = useSelector(getTransactionHistory);

  const transactionHistory = fullTransactionHistoryList.slice(
    0,
    TRANSACTION_HISTORY_CARD_ROW_LENGTH
  );

  const showTransactionHistoryItems = transactionHistory.length > 0;
  const showFullTransactionHistoryLink =
    fullTransactionHistoryList.length > TRANSACTION_HISTORY_CARD_ROW_LENGTH;

  return (
    <TransactionHistoryCardWrapper>
      <CardTitle>Transaction History</CardTitle>
      {showTransactionHistoryItems ? (
        <TransactionHistoryItems transactions={transactionHistory} shortList />
      ) : (
        <NoTransactionsText>
          There are no recent transactions for this account.
        </NoTransactionsText>
      )}

      {showFullTransactionHistoryLink && (
        <TransactionHistoryLink
          to={`/loan-detail/transaction-history/${vehicleId}`}
          onClick={handleLinkClick}
        >
          See full transaction history
        </TransactionHistoryLink>
      )}
    </TransactionHistoryCardWrapper>
  );
};

export default TransactionHistoryCard;
